import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PageTemplate, TopFixed, PageTitle, Container, TabsNavigation, CheckboxFilter, SearchFilter } from '../PageTemplate';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faEnvelope, faEnvelopeOpen} from '@fortawesome/fontawesome-free-solid';
import {Lead} from './';
import './leadsPage.scss';

class LeadsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: {
                text: "",
                contact: false,
                interested: false
            }
        }

        this.noFilter = this.noFilter.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onFilterTextChange = this.onFilterTextChange.bind(this);
        this.clearTextFilter = this.clearTextFilter.bind(this);
    }

    noFilter() {
        const {filter} = this.state;
        const noFilter = {...filter};
        noFilter.text = "";
        noFilter.contact = false;
        noFilter.interested = false;

        this.setState({filter: noFilter})
    }

    onFilterChange(event) {
        const {name} = event.target;
        const {filter} = this.state;
        const filters = {...filter};

        if(name === 'contact') filters.interested = false;
        else if(name === 'interested') filters.contact = false;
        

        if(filter.hasOwnProperty(name)){
            this.setState({filter: {...filters, [name]: !filter[name]}})
        }
    }

    onFilterTextChange(event) {
        const {value} = event.target;
        this.setState({filter: {...this.state.filter, text: value}});
    }

    clearTextFilter() {
        this.setState({filter: {...this.state.filter, text: ""}});
    }

    leadss() {
        const {leads} = this.props;
        const lids = leads && leads.list;
        const {filter} = this.state;

        let rows = [];
        if(lids) rows = lids.filter((item) => {
            let {phone, name, interested, contact} = item;
            let pass = true;

            // filter by phone or name
            if(
                filter.text && 
                filter.text.trim().length > 0 &&
                (!phone || !phone.includes(filter.text)) && // if phone is null skip phone includes
                !name.includes(filter.text)
            ) {
                pass = false;
            }

            // filter by interested not exists
            if(filter.interested && interested !== undefined) pass = false;

            // filter by contact (filter no intersted too)
            if(filter.contact && (contact !== false || interested !== true)) pass = false;

            return pass;
        }).map((item, index) => (<Lead data={item} key={index}/>)).reverse();

        return rows;
    }

    render() {
        const {leads} = this.props;
        const lids = leads && leads.list;
        const {text, contact, interested} = this.state.filter;

        let rows = [];
        if(lids) rows = lids.map((item, index) => (<Lead data={item} key={index}/>)).reverse();

        return (
            <PageTemplate id="leadsPage">
                <TopFixed>
                    <PageTitle>
                        <FontAwesomeIcon icon={faEnvelope} />&nbsp;לידים
                    </PageTitle>
                    <TabsNavigation>
                        <div className="sortTitle">
                            סינון:&nbsp;
                        </div>
                        <CheckboxFilter 
                            checked={!contact && !interested && text.length === 0}
                            name="noFilter"
                            onChange={this.noFilter}
                        >
                            ללא
                        </CheckboxFilter>
                        <CheckboxFilter
                            checked={interested}
                            name="interested"
                            onChange={this.onFilterChange}
                        >
                            לא נקראו
                        </CheckboxFilter>
                        <CheckboxFilter
                            checked={contact}
                            name="contact"
                            onChange={this.onFilterChange}
                        >
                            לא נוצר קשר
                        </CheckboxFilter>
                        <SearchFilter 
                            value={text} 
                            onChange={this.onFilterTextChange} 
                            clear={this.clearTextFilter} 
                            placeholder="סינון לפי שם או טלפון"
                        />
                    </TabsNavigation>
                    <div className={`leadsTitle ${rows.length == 0 ? 'hide' : ''}`}>
                        <div className="leadName">
                            שם
                        </div>
                        <div className="leadDate">
                            תאריך האירוע
                        </div>
                        <div className="leadArea">
                            מיקום האירוע
                        </div>
                        <div className="leadPhone">
                            טלפון
                        </div>
                        <div className="leadContact">
                            נוצר קשר
                        </div>
                    </div>
                </TopFixed>
                <Container>
                    {this.leadss()}
                </Container>
                <Container id="leadsPlaceholder" className={`${lids && rows.length == 0 ? 'show' : ''}`}>
                    <div className="pIcon">
                        <FontAwesomeIcon icon={faEnvelopeOpen} />
                    </div>
                    <div>
                        לא נמצאו לידים במערכת!
                    </div>
                </Container>
            </PageTemplate>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        leads: state.leadsReducer
    }
}

const LeadsPageWithRedux = connect(mapStateToProps)(LeadsPage);
export {LeadsPageWithRedux as LeadsPage};


// WEBPACK FOOTER //
// ./src/components/LeadsPage/LeadsPage.jsx